// The order of a server's sessions: the active ones first, then the last active first. A session never used counts
// from its creation.

const ACTIVE = ['active', 'processing', 'waiting_for_input', 'idle'];

/** When a session was last active: its last activity, or its creation for one never used */
export const lastActive = (s: { createdAt: string; lastActivityAt?: string }) => s.lastActivityAt || s.createdAt;

export function bySessionOrder<T extends { status: string; createdAt: string; lastActivityAt?: string }>(a: T, b: T): number {
  const active = (s: T) => (ACTIVE.includes(s.status) ? 0 : 1);
  return active(a) - active(b) || new Date(lastActive(b)).getTime() - new Date(lastActive(a)).getTime();
}
